import { Card } from "./typing";

export const defaultCardsList: Card[] = [
  {
    id: 1,
    text: "¿Qué es lo que más te cuesta decirle a las personas que querés?",
  },
  {
    id: 2,
    text: "Si pudieras borrar un momento de tu vida, ¿cuál sería y por qué?",
  },
  {
    id: 3,
    text: "¿Te considerás una persona más de mente o de corazón? ¿Por qué?",
  },
  {
    id: 4,
    text: "¿Qué creencias conspirativas creés que podrían ser ciertas?",
  },
  { id: 5, text: "¿Cómo te afecta la opinión de los demás sobre vos?" },
  {
    id: 6,
    text: "¿Hay algo que hayas hecho en tu vida de lo que nunca hablaste con nadie?",
  },
  { id: 7, text: "¿Qué es lo que más miedo te da perder?" },
  { id: 8, text: "Si pudieras cambiar una decisión en tu vida, ¿cuál sería?" },
  { id: 9, text: "¿Qué es lo que sentís que la gente no entiende sobre vos?" },
  { id: 10, text: "¿Cuál es el mayor sacrificio que hiciste por alguien más?" },
  { id: 11, text: "¿Qué opinás de la idea de que el destino está escrito?" },
  {
    id: 12,
    text: "Si pudieras vivir para siempre, ¿querrías hacerlo? ¿Por qué?",
  },
  {
    id: 13,
    text: "¿Creés que hay vida después de la muerte? ¿Qué te gustaría que hubiera?",
  },
  {
    id: 14,
    text: "¿Cómo sería tu mundo perfecto si pudieras crearlo desde cero?",
  },
  {
    id: 15,
    text: "Si te dijeran que hoy es tu último día, ¿qué es lo primero que harías?",
  },
  { id: 16, text: "¿Qué opinás del calentamiento global?" },
  { id: 17, text: "¿Por qué creés que existen las guerras?" },
  { id: 18, text: "¿Qué pensás sobre la desigualdad económica en el mundo?" },
  { id: 19, text: "¿Creés que el ser humano es naturalmente bueno o malo?" },
  { id: 20, text: "¿Qué es lo que te da esperanza en la humanidad?" },
  {
    id: 21,
    text: "¿Cómo creés que sería la vida si las máquinas tomaran el control?",
  },
  { id: 22, text: "¿Creés que estamos solos en el universo?" },
  {
    id: 23,
    text: "¿Qué pensás que hay en las profundidades del océano que aún no conocemos?",
  },
  {
    id: 24,
    text: "¿Por qué creés que algunas personas eligen el mal sobre el bien?",
  },
  { id: 25, text: "¿Qué significa para vos ser libre en este mundo?" },
  {
    id: 26,
    text: "¿Cuál crees que es el mayor desafío al que se enfrenta nuestra sociedad actualmente y por qué?",
  },
  {
    id: 27,
    text: "¿Cuál es tu opinión sobre la educación tradicional versus la educación en línea? ¿Cuáles son las ventajas y desventajas de cada una?",
  },
  {
    id: 28,
    text: "¿Estás a favor o en contra de los avances tecnológicos como la inteligencia artificial y la automatización? ¿Por qué?",
  },
  {
    id: 29,
    text: "¿Cuál es tu postura sobre los derechos de los animales? ¿Crees que deberían tener los mismos derechos que los seres humanos?",
  },
  {
    id: 30,
    text: "¿Cuál es tu opinión sobre la legalización de las drogas? ¿Crees que tendría más beneficios o más consecuencias negativas?",
  },
];
